<div class="horizontal-page-menu-item">
    <h1>{{title}}</h1>
    <div class="url-description">
        {{urlDescription}}
    </div>
    <div class="horizontal-page-menu-item-content">
        <ng-content></ng-content>
    </div>
</div>